import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { HandlerBase } from "./HandlerBase";
export var SelectionTargetHandler = /*#__PURE__*/function (_HandlerBase) {
  _inherits(SelectionTargetHandler, _HandlerBase);
  var _super = _createSuper(SelectionTargetHandler);
  function SelectionTargetHandler() {
    _classCallCheck(this, SelectionTargetHandler);
    return _super.apply(this, arguments);
  }
  _createClass(SelectionTargetHandler, [{
    key: "attachHandlers",
    value: function attachHandlers(domNode) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      /** is this method even required? Probably to stop links and buttons from working? */
      this.registerHandler([domNode].concat(args), 'mousedown', this.handleMouseDown.bind(this));
      this.registerHandler([domNode].concat(args), 'mouseover', this.handleMouseOver.bind(this));
      this.registerHandler([domNode].concat(args), 'mouseleave', this.handleMouseLeave.bind(this));
      this.registerHandler([domNode].concat(args), 'click', this.handleClick.bind(this));
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      event.stopPropagation();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }]);
  return SelectionTargetHandler;
}(HandlerBase);